import React from "react";
import { Paragraph, Spacing, Title } from "@sicredi/react";
import "./styles.scss";
import ResponsiveSpacing from "#/components/ResponsiveSpacing";
import { PageInfoPropsBase } from "./config";

export const PageInfo: React.FC<PageInfoPropsBase> = ({
  title,
  description,
}) => {
  return (
    <>
      <Title className="page-title" data-testid="page-title" as="h1">
        {title}
      </Title>
      {description ? (
        <>
          <ResponsiveSpacing
            appearanceDesktop="large"
            appearanceMobile="xx-small"
          />
          <Paragraph
            className="page-description"
            data-testid="page-description"
          >
            {description}
          </Paragraph>
          <Spacing appearance="medium" />
        </>
      ) : (
        <ResponsiveSpacing appearanceDesktop="large" appearanceMobile="small" />
      )}
    </>
  );
};
